export default __webpack_public_path__ + "cdb6e08f92c2adda73bc48f17500d170.jpg";